/**
 * Componente TextField Corporativo
 * Input reutilizable con estilos corporativos consistentes
 */

import React from 'react';
import { TextField, TextFieldProps, useTheme } from '@mui/material';
import { createInputStyles } from '../../theme/utils';

type CorporateTextFieldProps = TextFieldProps & {
  /**
   * Si se aplican estilos corporativos (por defecto true)
   */
  corporate?: boolean;
};

export const CorporateTextField: React.FC<CorporateTextFieldProps> = ({
  corporate = true,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const inputStyles = corporate ? createInputStyles(theme) : {};

  const customTheme = theme as any;
  const borderRadius = customTheme.custom?.shape?.borderRadius?.medium || 8;
  
  return (
    <TextField
      {...props}
      sx={{
        ...inputStyles,
        '& .MuiOutlinedInput-root': {
          borderRadius,
          ...(inputStyles as any)['& .MuiOutlinedInput-root'],
        },
        ...sx,
      }}
    />
  );
};

